/**
 * GsapGlobals — GSAP 3.x 공식 npm 의존성 (2026-05-28 승격, 이전 window.gsap 외부 로드 폐기).
 * ScrollTrigger 플러그인 자동 등록. 모든 home 인터랙션은 본 모듈의 getGsap() 로 인스턴스 접근.
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let registered = false;

function ensureRegistered(): void {
    if (registered) return;
    gsap.registerPlugin(ScrollTrigger);
    registered = true;
}

export function getGsap(): typeof gsap {
    ensureRegistered();
    return gsap;
}

export function getScrollTrigger(): typeof ScrollTrigger {
    ensureRegistered();
    return ScrollTrigger;
}

// 호환: 기존 window.gsap 의존 코드 1곳 (TypeMaskRevealController) 이 안전하게 fallback 하도록 노출
declare global {
    interface Window {
        gsap?: typeof gsap;
        ScrollTrigger?: typeof ScrollTrigger;
    }
}
if (typeof window !== "undefined") {
    ensureRegistered();
    window.gsap = gsap;
    window.ScrollTrigger = ScrollTrigger;
}
